var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#5E4635"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6769 39.8566C26.6727 40.3123 25.6013 40.6023 24.5044 40.7153C24.4319 40.7229 24.3589 40.7091 24.2941 40.6758C24.2294 40.6425 24.1757 40.5911 24.1397 40.5278C23.3269 39.0953 23.0597 37.3131 23.3897 35.3575C23.8106 32.8338 25.1794 30.3072 27.2447 28.2419C29.31 26.1766 31.8384 24.8078 34.3603 24.3869C36.4969 24.0316 38.4263 24.3869 39.9188 25.3806C39.9798 25.4208 40.0279 25.4778 40.0569 25.5449C40.086 25.6119 40.0949 25.686 40.0824 25.758C40.07 25.83 40.0368 25.8968 39.9869 25.9502C39.937 26.0035 39.8726 26.0412 39.8016 26.0585C39.099 26.2259 38.414 26.4601 37.7559 26.7578C35.715 27.686 33.1059 29.6697 32.2697 33.8547C31.6969 36.6935 30.1528 38.7128 27.6769 39.8566ZM41.8603 27.4731C41.8244 27.41 41.7708 27.3587 41.7063 27.3254C41.6417 27.2921 41.5688 27.2783 41.4966 27.2856C40.3992 27.3979 39.3274 27.688 38.3231 28.1444C35.8472 29.2881 34.3031 31.3075 33.735 34.1444C32.8978 38.3294 30.2897 40.3131 28.2487 41.2413C27.5907 41.539 26.9057 41.7732 26.2031 41.9406C26.1305 41.957 26.0645 41.9946 26.0133 42.0487C25.9621 42.1027 25.9282 42.1708 25.9159 42.2441C25.9035 42.3175 25.9132 42.3929 25.9439 42.4608C25.9745 42.5286 26.0246 42.5858 26.0878 42.625C27.2006 43.3675 28.5553 43.75 30.0581 43.75C30.5897 43.7485 31.1202 43.7033 31.6444 43.615C34.1672 43.1941 36.6947 41.8253 38.76 39.76C40.8253 37.6947 42.1941 35.1663 42.615 32.6444C42.9375 30.6888 42.6731 28.9056 41.8603 27.4731Z",
    fill: "#F0E9E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.58a7a60f00d97ba7e49fdd64d074f6e1.svg";
export { ForwardRef as ReactComponent };